/**
 * AdminPageHeader — the per-page H1 + description (Story UI-U6 AC1/AC10).
 *
 * H1 uses the display-title treatment (design.md §3): italic, tight tracking, via
 * `var(--font-display)` — the clean GT-Pressura swap point. Until UI-U1 defines
 * `--font-display`, the inline fallback resolves to italic Geist (documented
 * fallback). NO trial font files committed.
 *
 * [Source: docs/design/2026-07-10_sebastian-package/design.md §3]
 * [Source: docs/stories/ui-u1-foundation.md AC 2]
 */

import type { ReactNode } from 'react';

export function AdminPageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="mb-6 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-[26px] font-semibold italic tracking-tight [font-family:var(--font-display,inherit)]">
          {title}
        </h1>
        {description != null && (
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions != null && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
